import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-int.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { VoidUrl } from "@/common/types";
import { assert } from "@/common/assert";
import { formatImageUrl } from "@/common/utils";
import "./ChatNameCardMessageItem.scss";
import { UrlHelperExtensions } from "@/url_helpers";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
export default function ChatNameCardMessageItem(props) {
  var attr = props.message.customAttrs;
  assert(attr, "Oops, attr is falsy");
  var userId = attr.USER_ID_KEY;
  var userName = attr.USER_NAME_KEY;
  var clientId = attr.USER_CLIENT_ID_KEY; //todo
  // const isMobileUser = attr.

  var profession = attr.USER_PROFESSION_KEY;
  var companyName = attr.USER_COMPANY_NAME_KEY;
  var avatarUrl = attr.USER_AVATAR_URL_KEY;
  var userUrl = UrlHelperExtensions.$ProfileUrl(parseInt(userId, 10), {
    stat_ctx: "ChatMessage"
  });
  var previewImage = null;

  if (avatarUrl) {
    avatarUrl = formatImageUrl(avatarUrl, ImageSizeTypeEnum.Thumbnail100whFill);
    previewImage = _jsx("a", __assign({
      target: "_blank",
      href: userUrl,
      className: "user-card__avatar"
    }, {
      children: _jsx("img", {
        src: avatarUrl
      }, void 0)
    }), void 0);
  }

  return _jsx(React.Fragment, {
    children: _jsxs("div", __assign({
      className: "user-card"
    }, {
      children: [_jsxs("div", __assign({
        className: "user-card__content"
      }, {
        children: [previewImage, _jsxs("div", __assign({
          className: "user-card__info"
        }, {
          children: [_jsx("a", __assign({
            target: "_blank",
            href: userUrl,
            className: "user-card__name"
          }, {
            children: userName
          }), void 0), _jsxs("p", __assign({
            className: "user-card__info-company"
          }, {
            children: [_jsx("span", __assign({
              className: "user-card__profession",
              title: profession
            }, {
              children: profession
            }), void 0), _jsx("span", __assign({
              title: companyName
            }, {
              children: companyName
            }), void 0)]
          }), void 0)]
        }), void 0)]
      }), void 0), _jsxs("div", __assign({
        className: "user-card__btns"
      }, {
        children: [_jsx("a", __assign({
          className: "user-card__check-profile-btn",
          target: "_blank",
          href: userUrl
        }, {
          children: "\u67E5\u770B\u4E3B\u9875"
        }), void 0), _jsx("a", __assign({
          href: VoidUrl,
          className: "user-card__start-chat-btn js-start-chat",
          "data-user-client-id": clientId,
          "data-is-mobile-user": "true"
        }, {
          children: "\u53D1\u8D77\u804A\u5929"
        }), void 0)]
      }), void 0)]
    }), void 0)
  }, void 0);
}